const baseUrl = "https://api.yim-card.plaping-dc.com"
// const baseUrl = "http://localhost:8009"
const pageSize = 10
const dashboardUrl = "https://datastudio.google.com/embed/reporting/5e0b80b9-e56f-4d9a-91ec-4e913936384d/page/vAiTC";
const version = "1.3.0";

export {
  baseUrl, pageSize, dashboardUrl, version
}
